import { Clock } from 'three';
import { advanceMatchSimFrame } from './matchSimFrame.js';

/**
 * startMatchAnimateLoop — Camera + sim gate + HUD projections + render (P3-05).
 */
export function startMatchAnimateLoop({
  camera,
  renderer,
  scene,
  inputController,
  matchRuntime,
  matchOutcomeWire,
  mapObjectives,
  entityInspect,
  gameOrchestrator,
  buildTickContext,
  runOrchestratorTick,
  projectEntities,
  onFrameTick,
  minimap
} = {}) {
  const clock = new Clock();
  function animate() {
    requestAnimationFrame(animate);
    const dt = Math.min(clock.getDelta(), 0.1);
    if (typeof onFrameTick === 'function') onFrameTick(dt);
    // Sim before camera so locked follow uses this frame's champion pose (no 1-frame lag).
    advanceMatchSimFrame({
      matchRuntime,
      matchOutcomeWire,
      dt,
      runOrchestratorTick: () => {
        const ctx = buildTickContext(dt);
        if (typeof runOrchestratorTick === 'function') {
          return runOrchestratorTick(dt, ctx);
        }
        return gameOrchestrator.tick(dt, ctx);
      }
    });
    const camCenter = inputController.updateCamera(dt);
    camera.position.set(camCenter.x + 20, 25, camCenter.z + 20);
    camera.lookAt(camCenter.x, 0, camCenter.z);
    mapObjectives.syncVisuals();
    entityInspect.sync();
    projectEntities();
    if (minimap && typeof minimap.sync === 'function') minimap.sync();
    renderer.render(scene, camera);
  }
  animate();
}
